<div class="tw-flex tw-items-center tw-gap-3 tw-w-full">
  @if (stepLabel()) {
    <span class="tw-font-lexend tw-font-bold tw-text-300 tw-text-teal-500 tw-shrink-0">{{ stepLabel() }}</span>
  }
  <div class="tw-h-1 tw-flex-1 tw-rounded-full tw-bg-teal-100 tw-overflow-hidden">
    <div data-testid="quiz-progress-fill"
      class="tw-h-full tw-rounded-full tw-bg-teal-500 tw-transition-all tw-duration-500"
      [style.width.%]="percent()"></div>
  </div>
  <div role="button" tabindex="0"
    class="tw-shrink-0 tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
    (click)="onCloseClick()"
    (keydown.enter)="onCloseKeydown($event)"
    (keydown.space)="onCloseKeydown($event)">
    <em class="cs-icon-close tw-text-600 tw-text-gray-800"></em>
  </div>
</div>
